export var CorePhases;
(function (CorePhases) {
    CorePhases[CorePhases["instructions"] = 1] = "instructions";
    CorePhases[CorePhases["intro"] = 2] = "intro";
    CorePhases[CorePhases["intro2"] = 3] = "intro2";
    CorePhases[CorePhases["startList"] = 4] = "startList";
    CorePhases[CorePhases["discipline"] = 5] = "discipline";
    CorePhases[CorePhases["provisionalResults"] = 6] = "provisionalResults";
    CorePhases[CorePhases["finalResults"] = 7] = "finalResults";
})(CorePhases || (CorePhases = {}));
//# sourceMappingURL=index.js.map